import { render, staticRenderFns } from "./CALoadInScreen.vue?vue&type=template&id=4bafbfdc&scoped=true&"
import script from "./CALoadInScreen.vue?vue&type=script&lang=js&"
export * from "./CALoadInScreen.vue?vue&type=script&lang=js&"
import style0 from "./CALoadInScreen.vue?vue&type=style&index=0&id=4bafbfdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bafbfdc",
  null
  
)

export default component.exports